import { Component, Input, OnInit } from '@angular/core';
import { ToolboxCandidateModel } from 'projects/core/src/lib/models/toolbox-candidate.model';

@Component({
  selector: 'app-toolbox-candidate-new',
  templateUrl: './toolbox-candidate-new.component.html',
  styleUrls: ['./toolbox-candidate-new.component.scss']
})
export class ToolboxCandidateNewComponent implements OnInit {

  @Input() order: ToolboxCandidateModel = null;

  constructor() { }

  ngOnInit(): void {
  }

}
